import React from 'react';
import styled from 'styled-components';
import cx from 'classnames';

const StyledLayout = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

interface LayoutProps {
    className?: string;
    children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children, className }) => {
    return <StyledLayout className={cx(className)}>{children}</StyledLayout>;
};

export default Layout;
